/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_TotalInputs */

const da_forside_preview_total = /** @type {(inputs: Forside_Preview_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 30 point`)
};

/** @type {(inputs: Forside_Preview_TotalInputs) => LocalizedString} */
const en_forside_preview_total = da_forside_preview_total;

/**

* @param {Forside_Preview_TotalInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_total = /** @type {((inputs?: Forside_Preview_TotalInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_TotalInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_total(inputs)
	return /** @type {LocalizedString} */ ("/ 30 point")
});